import { AwsRum } from "aws-rum-web";
import getEnvConfig from "../config";
import { setupXbLogging } from "./xbLogging";

const findXbAppName = (): string | undefined => {
  try {
    return getEnvConfig().aws_rum_application?.xb_app_name;
  } catch {
    return undefined;
  }
};

/**
 * Exposes the RUM client on window.cwr, which xb-lite reads when a logger is created, and routes XB
 * metrics to RUM when this host feeds an XB-Lite application. Call before React renders.
 */
export const setupXbMonitoring = (awsRum: AwsRum | undefined): void => {
  try {
    if (awsRum) {
      window.cwr = awsRum;
    }

    const xbAppName = findXbAppName();
    const xbEnvironment = window.GameEnvironment?.config?.aws_rum_config?.xb_environment;
    if (!awsRum || !xbAppName || !xbEnvironment) {
      return;
    }

    setupXbLogging({ appName: xbAppName, environment: xbEnvironment });
  } catch (error) {
    console.error("Failed to set up XB monitoring", { error });
  }
};
